import React from 'react';

/**
 * Renderiza el bloque CauseHeader de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function CauseHeader({
  v
}) {
  return React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "1.666667vh",
      "flexWrap": "wrap"
    }
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.185185vh"
    }
  }, React.createElement("h2", {
    style: {
      "margin": "0",
      "fontSize": "1.574074vh",
      "fontWeight": "600"
    }
  }, v.text("¿Qué explica la pérdida de alimento?")), React.createElement("span", {
    style: {
      "fontSize": "1.111111vh",
      "color": "#8793a6"
    }
  }, v.text(v.czSub))), React.createElement("div", {
    style: {
      "marginLeft": "auto",
      "display": "flex",
      "gap": "1.296296vh",
      "alignItems": "center",
      "flexWrap": "wrap"
    }
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "0.925926vh",
      "color": "#8793a6",
      "letterSpacing": "0.06em",
      "textTransform": "uppercase"
    }
  }, v.text("Jaula")), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh"
    }
  }, (v.czScopeO || []).map((m, index80) => React.createElement(React.Fragment, {
    key: index80
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.37037vh 0.925926vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color,
      "fontWeight": m.fw,
      "whiteSpace": "nowrap"
    }
  }, v.text(m.label)))))), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "0.925926vh",
      "color": "#8793a6",
      "letterSpacing": "0.06em",
      "textTransform": "uppercase"
    }
  }, v.text("Período")), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh"
    }
  }, (v.czPerO || []).map((m, index81) => React.createElement(React.Fragment, {
    key: index81
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.37037vh 0.925926vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color,
      "fontWeight": m.fw,
      "whiteSpace": "nowrap"
    }
  }, v.text(m.label)))))), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "0.925926vh",
      "color": "#8793a6",
      "letterSpacing": "0.06em",
      "textTransform": "uppercase"
    }
  }, v.text("Explicar")), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh"
    }
  }, (v.czOutO || []).map((m, index82) => React.createElement(React.Fragment, {
    key: index82
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.37037vh 0.925926vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color,
      "fontWeight": m.fw,
      "whiteSpace": "nowrap"
    }
  }, v.text(m.label))))))));
}
